import { render, staticRenderFns } from "./outPriceDetailModal.vue?vue&type=template&id=40f52032&"
import script from "./outPriceDetailModal.vue?vue&type=script&lang=js&"
export * from "./outPriceDetailModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports